<template>
  <el-container class="home-wrap">
    <!-- 地理位置信息 -->
    <el-header style="padding:0;height:20%;">
      <div class="home-header-box flex-row-between" v-loading="isloading">
        <div class="flex-row-start" style="align-items:start;">
          <img :src="$Image('gf.png')" alt="">
          <div v-if="location !== ''" class="home-header-text">
            <div style="color: #333333;">{{location}}</div>
            <div class="update-time"> {{$t('Updated {times} ago', { times: this.refreshTime })}} </div>
          </div>
          <div v-else class="home-header-text">
            <div style="text-align: center;">{{$t('No location information')}} <img @click="locationProblem" :src="$Image('problem.png')" alt=""> </div>
          </div>
        </div>
        <img v-if="isRefresh" @click="onRefresh(true)" :src="$Image('Refresh.png')" alt="">
        <div v-else class="flex-row-end">
          <label class="wait_hide">{{$t('please wait...')}}</label>
          <i class="el-icon-loading" style="font-size:20px;margin-left:6px;"></i>
        </div>
      </div>
    </el-header>
    <!-- Screen time apps -->
    <el-main>
      <div class="flex-row-between home-main-box">
        <!-- 屏幕时间 -->
        <div class="home-main-left" v-loading="isloading">
          <div class="flex-row-between main-left-header">
            <div style="font-size: 20px;color: #333333;">{{$t('Screen Time')}}</div>
            <!-- Screen time select-->
            <el-select v-model="selectDate" @change="changeSelect" size="mini" placeholder="Today" class="select-time">
              <el-option
                v-for="(date, i) in allDates" :key="i" :label="date.label" :value="date.value">
              </el-option>
            </el-select>
          </div>
          <!-- 饼图 id="screen-time" -->
          <div v-show="showpm" class="flex-col-center" style="height:80%;width:100%">
            <div class="screen-allTimes">{{dateFormatterHome(allTimes)}}</div>
            <div v-show="screenActivities.length > 0 && this.$route.query.android === 'Windows'"  id="screen-time" ref="chart" class="flex-row-center" style="width:100%;height:70%;"></div>
            <div v-show="mostUsedDatas.length > 0 && this.$route.query.android === 'Android'"  id="screen-time" ref="charts" class="flex-row-center" style="width:100%;height:70%;"></div>
            <!-- <div v-if="!isNoData" class="flex-col-center" style="height:80%">
              <img :src="$Image('nodata.png')" alt="">
              <div class="nodata-display">{{$t('No data found')}}</div>
            </div> -->
            <!-- <div v-if="this.$route.query.android === 'Android' && isNoData"  id="screen-time" ref="chart" class="flex-row-center" style="width:100%;height:70%;"></div> -->
          </div>
          <!--  no apps datas  -->
          <div v-if="!showpm" class="flex-col-center" style="height:80%">
            <img :src="$Image('nodata.png')" alt="">
            <div class="nodata-display">{{$t('No data found')}}</div>
          </div>
        </div>
        <!--  apps  -->
        <div class="home-main-right" v-loading="isloading">
          <div class="main-right-header">{{$t('Most Used')}}</div>
          <!--  apps datas  -->
          <div v-if="mostUsedDatas && mostUsedDatas.length > 0" class="main-right-content">
            <div v-for="(item, i) in mostUsedDatas" :key="i" class="flex-row-between used-app-item">
              <div class="flex-row-start" style="width:100%;">
                <img style="width:12%;" :src="item.Icons" alt="">
                <div style="width:100%;margin-left:20px;">
                  <div class="app-name">{{item.AppNames}}</div>
                  <div class="app-used-time flex-row-between">
                    <div>{{$t('Used for')}} {{dateFormatter(item.TotalTime)}}</div>
                    <div style="font-size:14px;">{{item.AppType === '0' ? 'Other' : (item.AppType === '1' ? 'Game' : 'Social')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--  no apps datas  -->
          <div v-else class="flex-col-center" style="height:80%">
              <img :src="$Image('nodata.png')" alt="">
              <div class="nodata-display">{{$t('No data found')}}</div>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import echarts from 'echarts'
const add0 = (num) => {
  return num < 10 ? '0' + num : '' + num
}
const selectDate = {
  Last_7_Days: 'Last 7 Days',
  Yesterday_Days: 'Yesterday',
  Today_Days: 'Today'
}
export default {
  name: 'home',
  props: ['userid', 'device'],
  inject: ['rootMenu'],
  data () {
    return {
      title: '',
      isNoData: false,
      NoData: false,
      showpm: false,
      value: 0,
      appList: [],
      selectDate: selectDate.Last_7_Days,
      allDates: [
        { label: this.$t('Today'), value: selectDate.Today_Days },
        { label: this.$t('Yesterday'), value: selectDate.Yesterday_Days },
        { label: this.$t('Last 7 Days'), value: selectDate.Last_7_Days }
      ],
      mostUsedDatas: [],
      isloading: false,
      longest: 0,
      other: null,
      game: null,
      social: null,
      allTimes: 0,
      refreshTime: '',
      beforeTimeData: 0,
      location: '',
      allClassify: [
        {value: 0, name: this.$t('Social')},
        {value: 0, name: this.$t('Other')},
        {value: 0, name: this.$t('Game')}
      ],
      isRefresh: true,
      allTimeDate: [],
      screenActivities: []
    }
  },
  methods: {
    getEachertDatas (activities) {
      let barDv = this.$refs.chart
      const myChart = echarts.init(barDv)
      const opts = {
        title: {
          text: ''
        },
        tooltip: {
          showContent: false
        },
        xAxis: {
          data: [activities[6].date, activities[5].date, activities[4].date, activities[3].date, activities[2].date, activities[1].date, activities[0].date],
          axisLabel: {
            interval: 0
          }
        },
        yAxis: {
          max: 8,
          axisLabel: {
            showMaxLabel: true
          }
        },
        series: [
          {
            markLine: {
              data: [
                { type: 'average' }
              ],
              symbol: ['none', 'none'],
              position: 'insideTopCenter',
              large: true
            },
            type: 'bar',
            data: [activities[6].TotalTime, activities[5].TotalTime, activities[4].TotalTime, activities[3].TotalTime, activities[2].TotalTime, activities[1].TotalTime, activities[0].TotalTime],
            itemStyle: {
              normal: {
                color: function (params) {
                  if (activities[0].selectDate === 'Yesterday') {
                    let colorList = ['#fff', '#fff', '#fff', '#fff', '#fff', '#2bcf88', '#fff']
                    return colorList[params.dataIndex]
                  } else if (activities[0].selectDate === 'Today') {
                    let colorList = ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#2bcf88']
                    return colorList[params.dataIndex]
                  } else {
                    let colorList = ['#2bcf88', '#2bcf88', '#2bcf88', '#2bcf88', '#2bcf88', '#2bcf88', '#2bcf88']
                    return colorList[params.dataIndex]
                  }
                },
                borderWidth: 1,
                borderColor: '#333',
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            }
          }
        ]
      }
      myChart.setOption(opts)
      window.onresize = myChart.resize
    },
    getEachertData (activities) {
      let barDv = this.$refs.charts
      const myChart = echarts.init(barDv)
      const opts = {
        legend: {
          orient: 'horizontal',
          bottom: 0,
          data: activities
        },
        series: [
          {
            name: this.$t('Screen time'),
            type: 'pie',
            radius: ['30%', '40%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
              left: 20
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = ['#FF7E55', '#FFB138', '#3AA7FF']
                  return colorList[params.dataIndex]
                },
                label: {
                  show: true,
                  // formatter: '{b}: {c} : {d} %'
                  formatter: function (obj) {
                    // console.log(obj.value)
                    if (obj.value === 0) {
                      return 0 + 'min'
                    }
                    const min = parseInt(obj.value / 1000 / 60)
                    const hours = parseInt(min / 60)
                    const sec = parseInt((obj.value / 1000) - (min * 60))
                    const minAdjust = parseInt(min - (60 * hours))
                    // const add0 = (num) => { return num < 10 ? '0' + num : '' + num }
                    if (sec < 60 && obj.value !== 0 && minAdjust === 0 && hours === 0) {
                      return '<1 mins'
                    } else if (hours === 0) {
                      return obj.name + ' : ' + minAdjust + 'mins'
                    } else {
                      return obj.name + ' : ' + hours + 'h' + minAdjust + 'mins'
                    }
                  }
                },
                labelLine: {
                  show: false
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: activities
          }
        ]
      }
      myChart.setOption(opts)
      window.onresize = myChart.resize
    },
    async getData () {
      console.log(this.selectDate)
      this.isloading = true
      this.isNoData = false
      try {
        console.log(this.allTimeDate)
        const datas = await this.$http.get(`MDM/DayActivity?date=Last 7 Days`)
        this.screenActivities = datas.data.data
        console.log(datas.data.data)
        // let setData = datas.data.data
        if (this.screenActivities.length !== 0) {
          this.showpm = true
          this.isNoData = true
          let T = this.allTimeDate
          let list = []
          for (let index = 0; index < T.length; index++) {
            const element = {}
            element.date = T[index]
            list.push(element)
          }
          list.map((a) => {
            console.log(a)
            a.TotalTime = 0
            a.selectDate = this.selectDate
            for (let index = 0; index < datas.data.data.length; index++) {
              if (a.date === datas.data.data[index].Date) {
                a.TotalTime = Number(this.dateTimeHour(Number(datas.data.data[index].TotalTime)))
              }
            }
          })
          console.log(list)
          this.$nextTick(function () {
            this.getEachertDatas(list)
          })
          const AppActivitydatas = await this.$http.get(`MDM/AppActivity?date=${this.selectDate}`)
          this.appList = AppActivitydatas.data.data
          this.appList.map((c) => {
            c.Icons = `${this.STS_URL}` + '/' + c.AppNames + '.png'
          })
          // 筛选第三方App
          let appTypeList = []
          appTypeList = (this.appList.filter(c => c.Type === '1'))
          console.log(appTypeList)
          this.mostUsedDatas = (appTypeList.filter(c => c.TotalTime > 0)).slice(0, 3)
        } else {
          this.mostUsedDatas = []
          this.appList = []
          this.showpm = false
        }
      } catch (error) {
        console.log(error)
      }
      this.isloading = false
    },
    async getDatas () {
      console.log(this.selectDate)
      this.isloading = true
      this.isNoData = false
      try {
        // console.log(this.device)
        const datas = await this.$http.get(`MDM/AppActivity?date=${this.selectDate}`)
        this.appList = datas.data.data
        console.log(this.appList)
        if (this.appList.length !== 0) {
          this.showpm = true
          this.isNoData = true
          this.appList.map((c) => {
            c.Icons = `${this.STS_URL}` + '/' + c.AppNames + '.png'
          })
          // 筛选第三方App
          let appTypeList = []
          appTypeList = (this.appList.filter(c => c.Type === '1'))
          console.log(appTypeList)
          this.mostUsedDatas = (appTypeList.filter(c => c.TotalTime > 0)).slice(0, 3)
          // 其他类别
          this.other = appTypeList.filter(c => c.AppType === '0')
          let othertimes = 0
          this.other.forEach((c) => {
            othertimes += parseInt(c.TotalTime)
          })
          // 游戏类别
          this.game = appTypeList.filter(c => c.AppType === '1')
          let gametimes = 0
          this.game.forEach((c) => {
            gametimes += parseInt(c.TotalTime)
          })
          // 社交应用
          this.social = appTypeList.filter(c => c.AppType === '2')
          let socialtimes = 0
          this.social.forEach((c) => {
            socialtimes += parseInt(c.TotalTime)
          })
          // 分类后的屏幕使用总时长
          this.allClassify.map((c) => {
            if (c.name === 'Game') {
              c.value = 0
              c.value += gametimes
            } else if (c.name === 'Social') {
              c.value = 0
              c.value += socialtimes
            } else {
              c.value = 0
              c.value += othertimes
            }
          })
          console.log(this.allClassify)
          this.$nextTick(function () {
            this.getEachertData(this.allClassify)
          })
          // 总共时长
          this.allTimes = othertimes + gametimes + socialtimes
        } else {
          this.isNoData = true
          this.mostUsedDatas = []
          this.allTimes = 0
          this.showpm = false
        }
      } catch (error) {
        console.log(error)
      }
      this.isloading = false
    },
    updateSync: function (data) {
      this.isRefresh = true
      let currentDate = new Date().getTime()
      this.refreshTime = this.dateFormatter(currentDate - (data.syncTime * 1000))
      this.location = data.location
    },
    syncTimeChange (syncDatas) {
      // console.log(syncDatas)
      let currentDate = new Date().getTime()
      this.refreshTime = this.dateFormatter(currentDate - (syncDatas.syncTime * 1000))
      this.location = syncDatas.location
    },
    async changeSelect () {
      if (this.$route.query.android === 'Windows') {
        this.allTimes = 0
        const datas = await this.$http.get(`MDM/DayActivity?date=${this.selectDate}`)
        let allTime = 0
        for (let index = 0; index < datas.data.data.length; index++) {
          allTime += Number(datas.data.data[index].TotalTime)
          console.log(allTime)
          this.allTimes = allTime
        }
        this.getData()
      } else {
        this.getDatas()
      }
    },
    onRefresh (type) {
      if (this.$Demo) {
        setTimeout(() => {
          this.isRefresh = true
        }, 5000)
      }
      this.isRefresh = false
      if (type) {
        this.rootMenu.Refresh(true)
      }
    },
    // 获取不到位置信息，点击问号 弹框提醒
    locationProblem () {
      const h = this.$createElement
      this.$msgbox({
        customClass: 'message-Nolocation',
        title: 'No location information',
        message: h('h2', null, [
          h('p', { style: 'font-size: 26px;color: #333333;line-height: 54px;font-weight: normal;margin-bottom: 30px;' }, this.$t('Please confirm')),
          h('p', { style: 'font-size: 18px;color: #333333;line-height: 30px;font-weight: normal;margin-bottom: 30px;text-align: left;' }, this.$t('1. The childs mobile phone is connected to the Internet and the position switch is turned on.')),
          h('p', { style: 'font-size: 18px;color: #333333;line-height: 30px;font-weight: normal;margin-bottom: 30px;text-align: left;' }, this.$t('2. Whether the famikit in the childs mobile phone is turned on.'))
        ]),
        confirmButtonText: this.$t('OK'),
        confirmButtonClass: 'Nolocation-btn',
        center: true,
        showClose: false
      }).then(() => {
      }).catch(() => {
      })
    },
    dateFormatter: function (aDate) {
      let date = this.$Formatter.duration(aDate / 1000)
      return date
    },
    dateFormatterHome: function (aDate) {
      let date = this.$Formatter.durationHome(aDate / 1000)
      return date
    },
    dateTimeHour (aDate) {
      let date = this.$Formatter.durationSreenTime(aDate / 1000)
      return date
    },
    YearMonthFormatter: function (aDate) {
      let date = this.$Formatter.date(aDate)
      let result = date.split(',')
      return `${result[0]}, ${result[1]}`
    },
    GetstartDateStr (a) {
      let dd = new Date()
      if (a) {
        dd.setDate(dd.getDate() - a)
      }
      let y = dd.getFullYear()
      let m = add0(dd.getMonth() + 1)
      let d = add0(dd.getDate())
      return y + '-' + m + '-' + d
    }
  },
  async mounted () {
    console.log(this.$route.query.android)
    this.changeSelect()
    this.rootMenu.$on('beforeTimeChange', this.syncTimeChange)
    this.rootMenu.$on('updateSync', this.updateSync)
    this.rootMenu.$on('onRefresh', this.onRefresh)
    let data = this.GetstartDateStr()
    let data1 = this.GetstartDateStr(1)
    let data2 = this.GetstartDateStr(2)
    let data3 = this.GetstartDateStr(3)
    let data4 = this.GetstartDateStr(4)
    let data5 = this.GetstartDateStr(5)
    let data6 = this.GetstartDateStr(6)
    let allData = [data, data1, data2, data3, data4, data5, data6]
    this.allTimeDate = allData
  },
  async created () {
    let date = new Date().valueOf()
    this.title = this.YearMonthFormatter(new Date(date))
    // if (this.$route.query.android === 'Windows') {
    //   this.allTimes = 0
    //   const datas = await this.$http.get(`MDM/DayActivity?date=${this.selectDate}`)
    //   let allTime = 0
    //   for (let index = 0; index < datas.data.data.length; index++) {
    //     allTime += Number(datas.data.data[index].TotalTime)
    //     console.log(allTime)
    //     this.allTimes = allTime
    //   }
    //   this.getData()
    // } else {
    //   this.getDatas()
    // }
  },
  watch: {
    async '$route' (to, from) {
      console.log(to, from)
      if (to.name === 'Home' && this.$route.query.android === 'Windows') {
        this.allTimes = 0
        const datas = await this.$http.get(`MDM/DayActivity?date=${this.selectDate}`)
        let allTime = 0
        for (let index = 0; index < datas.data.data.length; index++) {
          allTime += Number(datas.data.data[index].TotalTime)
          console.log(allTime)
          this.allTimes = allTime
        }
        this.getData()
      } else {
        this.getDatas()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.home-wrap{
  // padding:40px 40px 0 40px;
  width: 100%;
  .home-header-box{
  width: 100%;
  padding:2%;
  box-sizing: border-box;
  background-color: #ffffff;
  box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  .home-header-text{
    text-align:left;
    font-size:18px;
    margin-left:30px;
    .update-time{
      margin-top:15px;
      font-size:16px;
      color:#888888;
    }
  }
}
}
.home-main-box{
  padding-top:2%;
  box-sizing: border-box;
  flex-wrap: wrap;
  height: 100%;
  .home-main-left{
    width: 49%;
    height: 100%;
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px
      rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    .main-left-header{
      height:69px;
      padding:0 25px;
      border-bottom:1px solid #e5e5e5;
      .select-time {
        .el-input--mini .el-input__inner{
        width:142px;
        height:32px;
        border-radius: 16px;
       }
      }
    }
  }
  .home-main-right{
    width: 49%;
    height: 100%;
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px
      rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    .main-right-header{
      height:69px;
      line-height: 69px;
      color:rgb(51, 51, 51);
      font-size:20px;
      text-align:left;
      padding:0 25px;
    }
    .main-right-content{
      padding:0 30px;
      .used-app-item{
        width:100%;
        margin-top:30px;
        .app-name{
          text-align: left;
          font-size:18px;
          color:#333333;
        }
        .app-used-time{
          width:100%;
          font-size:18px;
          color:#888;
          margin-top:10px;
        }
      }
    }
  }
}
.screen-allTimes{
  font-family: Nunito SemiBold;font-size: 36px;font-weight: normal;font-stretch: normal;line-height: 54px;color: #333333;
}
#screen-time{
  width: 100% !important;
}
@media (min-width: 1024px){
  .home-wrap{
   height: 90%;
  }
}
@media (max-width: 1024px){
  .home-main-box {
    flex-flow: column nowrap;
  }
  .home-main-box .home-main-left, .home-main-box .home-main-right{
    width: 100%;
    margin-bottom: 20px;
    height: 500px;
  }
  .home-main-box .home-main-right .main-right-content{
    padding: 0 30px 160px;
  }
  #screen-time{
    div{
      width: 100% !important;
    }
    canvas {
      width: 100% !important;
    }
  }
  .home-wrap .home-header-box .home-header-text{
    font-size: 16px;
  }
  .home-wrap .home-header-box .home-header-text .update-time{
    font-size: 14px;
  }
  .wait_hide {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue